import React, { useEffect } from 'react'
import './styles/MainStyle.css'
import './styles/AiDeLStyle.css';
import Axios from 'axios';
import {useState} from 'react';
import useSound from 'use-sound';
import TargetGroß from './components/TargetGroß';
import World from './components/World';
import Tutor from './components/Tutor';
import Stimulus from './components/Stimulus';
import Button from './components/Button';
import TargetKlein from './components/TargetKlein';
import abschluss from './assets/audio/AbschlussD.mp3';
import timeSound from './assets/audio/Time.mp3';
import stimSound from './assets/audio/Stimulus.mp3';
import targetSound from './assets/audio/TargetD.mp3';
import mod24 from './assets/audio/Moderation23D.mp3';
import mod23 from './assets/audio/Moderation22D.mp3';
import mod22 from './assets/audio/Moderation21D.mp3';
import mod21 from './assets/audio/Moderation20D.mp3';
import mod1 from './assets/audio/Moderation1D.mp3';
import mod2 from './assets/audio/Moderation2D.mp3';
import mod3 from './assets/audio/Moderation3D.mp3';
import mod4 from './assets/audio/Moderation4D.mp3';
import mod5 from './assets/audio/Moderation5D.mp3';
import mod6 from './assets/audio/Moderation6D.mp3';
import mod7 from './assets/audio/Moderation7D.mp3';
import mod8 from './assets/audio/Moderation8D.mp3';
import mod9 from './assets/audio/Moderation9D.mp3';
import mod10 from './assets/audio/Moderation10D.mp3';
import mod11 from './assets/audio/Moderation11D.mp3';
import mod12 from './assets/audio/Moderation12D.mp3';
import mod13 from './assets/audio/Moderation13D.mp3';
import buttonSound from './assets/audio/Button.mp3';
import loginSound from './assets/audio/LoginSound.mp3';
import modRe1 from './assets/audio/RetestModeration1.mp3'
import l1 from './assets/audio/L1D.mp3';
import l2 from './assets/audio/L2D.mp3';
import l3 from './assets/audio/L3D.mp3';
import l4 from './assets/audio/L4D.mp3';
import l5 from './assets/audio/L5D.mp3';
import l6 from './assets/audio/L6D.mp3';
import l7 from './assets/audio/L7D.mp3';
import l8 from './assets/audio/L8D.mp3';
import l1m from './assets/audio/L1M.mp3';
import l2m from './assets/audio/L2M.mp3';
import l1s from './assets/audio/L1S.mp3';
import l2s from './assets/audio/L2S.mp3';
import E_Entenerpel from './assets/audio/E_Entenerpel.mp3';
import E_Feigenkerne from './assets/audio/E_Feigenkerne.mp3';
import E_downloaden from './assets/audio/E_downloaden.mp3';
import E_geliket from './assets/audio/E_geliket.mp3';
import E_gelogen from './assets/audio/E_gelogen.mp3';
import E_Notenhefte from './assets/audio/E_Notenhefte.mp3';
import E_Pudelbeine from './assets/audio/E_Pudelbeine.mp3';
import E_verbogen from './assets/audio/E_verbogen.mp3';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';



function AiDe_LE() {

    disableBodyScroll(document);
    const version = "6.2.1";
    const connect = "offline";

    {/*Variablen Meta*/ }
    const itemAnzahlPhase1 = 20;
    const testDauerPhase2 = 120000;
    const [kurzVersion, setKurzVersion] = useState(false);
    const Api = "https://ranking.leadlernendigital.de/api/";
    {/*Variablen Meta*/ }

    {/*Variablen Login*/ }
    const queryParams = new URLSearchParams(window.location.search);
    const userCode = "kluug"
    const schulerCode = queryParams.get('schulerCode');
    const testTicket = queryParams.get('testticket');
    const schulerKlasse = queryParams.get('klassenstufe');
    const schulerVorname = queryParams.get('vorname');
    const lead = queryParams.get('lead');
    const aktuelleMaxKlasse = 4;
    const [testbogen, setTestbogen] = useState("AiDe-L-M1");
    const [reTest, setReTest] = useState("false");
    const [modus, setModus] = useState("aide");
    const [rechtsy, setRechtsy] = useState(true);
    const [itemsDa, setItemsDa] = useState(false);
    const [ticketMonitor, setTicketMonitor] = useState("TicketMonitor gone");
    const [repeatButton, setRepeatButton] = useState("RepeatButton gone");
    const [LE_StartBut, setLE_StartBut] = useState('LE_StartBut gone');
    const [viewAbschlussSeite, setViewAbschlussSeite] = useState('AbschlussSeite gone');
    {/*Variablen Login*/ }

  
    {/*Variablen Visuelles*/ }
    const[Szene, setSzene] = useState("startschreibtisch");
    const [LoginButton, setLoginButton] = useState('LoginButton');
    const [StartButton, setStartButton] = useState('StartButton gone');
    const [DatenSeite, setDatenSeite] = useState('datenseite sichtbar');
    const [rndCodebut, setRndCodebut] = useState("ZufallsCodeButton");
    const [RechtshanderButtonaktiv, setRechtshanderButtonaktiv] = useState('RechtshanderButton aktiv')
    const [LinkshanderButtonaktiv, setLinkshanderButtonaktiv] = useState('LinkshanderButton inaktiv')
    const [SchulerCodeFeld, setSchulerCodeFeld] = useState('SchulerCodeFeld');
    const [PlusButton, setPlusButton] = useState('PlusButton');
    const [MinusButton, setMinusButton] = useState('MinusButton');
    const [DiagnoseSeite, setDiagnoseSeite] = useState ('diagnoseseite gone');
    const [TargetVisible, setTargetVisible] = useState ('TargetWrapperGroß gone');
    const [ButtonBereich, setButtonBereich] = useState ('ButtonBereich');
    const [ButtonLinks, setButtonLinks] = useState('ButtonLinks gone');
    const [ButtonRechts, setButtonRechts] = useState('ButtonRechts gone');
    const [ButtonLinksType, setButtonLinksType] = useState('Inaktiv');
    const [ButtonRechtsType, setButtonRechtsType] = useState('Inaktiv');
    const [TargetKleinVisible, setTargetKleinVisible] = useState('TargetKleinWrapper gone');
    const [WeiterButton, setWeiterButton] = useState('WeiterButton gone');
    const [StimulusWrapper, setStimulusWrapper] = useState("StimulusWrapper gone");
    const [progress, setProgress] = useState(0.0);
    const [progressBarVisible, setProgressBarVisible] = useState("ProgressbarWrapper gone");
    const [theLightSide, setTheLightSide] = useState(255);
    const [theDarkSide, setTheDarkSide] = useState(0);
    const [mood, setMood] = useState(7);
    const [forceSteps, setForceSteps] = useState(0);
    const [TutorScreen, setTutorScreen] = useState('Android');
    const [TutorText, setTutorText] = useState('0');
    const [Theme, setTheme] = useState('SecretDucks');
    const [FastLoginPop, setFastLoginPop] = useState('FastLoginPop');
    const [LoginOfflinePop, setLoginOfflinePop] = useState('FastLoginPop gone');
    const [FastLoginError, setFastLoginError] = useState("");
    const [pwd, setPwd] = useState();
    const [FastloginPwd, setFastloginPwd] = useState('FastloginPwd');
    
    {/*Variablen Visuelles*/ }

    {/*Variablen Audio*/ }  
    const [playButtonSound] = useSound(buttonSound);
    const [abschlussSound] = useSound(abschluss);
    const [playTimeSound] = useSound(timeSound);
    const [playStim] = useSound(stimSound);
    const [playTarget] = useSound(targetSound);
    const [playLogin] = useSound(loginSound);
    const [moderation24] = useSound(mod24);
    const [moderation23] = useSound(mod23);
    const [moderation22] = useSound(mod22);
    const [moderation21] = useSound(mod21);
    const [moderation1] = useSound(mod1);
    const [moderation2] = useSound(mod2);
    const [moderation3] = useSound(mod3);
    const [moderation4] = useSound(mod4);
    const [moderation5] = useSound(mod5);
    const [moderation6] = useSound(mod6);
    const [moderation7] = useSound(mod7);
    const [moderation8] = useSound(mod8);
    const [moderation9] = useSound(mod9);
    const [moderation10] = useSound(mod10);
    const [moderation11] = useSound(mod11);
    const [moderation12] = useSound(mod12);
    const [moderation13] = useSound(mod13);
    const [moderationRe1] = useSound(modRe1);
    const [lob1] = useSound(l1);
    const [lob2] = useSound(l2);
    const [lob3] = useSound(l3);
    const [lob4] = useSound(l4);
    const [lob5] = useSound(l5);
    const [lob6] = useSound(l6);
    const [lob7] = useSound(l7);
    const [lob8] = useSound(l8);
    const [lobM1] = useSound(l1m);
    const [lobM2] = useSound(l2m);
    const [lobS1] = useSound(l1s);
    const [lobS2] = useSound(l2s);
    const [e_downloaden] = useSound(E_downloaden);
    const [e_Entenerpel] = useSound(E_Entenerpel);
    const [e_Feigenkerne] = useSound(E_Feigenkerne);
    const [e_geliket] = useSound(E_geliket);
    const [e_gelogen] = useSound(E_gelogen);
    const [e_Notenhefte] = useSound(E_Notenhefte);
    const [e_Pudelbeine] = useSound(E_Pudelbeine);
    const [e_verbogen] = useSound(E_verbogen);
     {/*Variablen Audio*/ }  

    {/*Variablen Testung*/ }
    const [TargetText, setTargetText] = useState('Entenerpel');
    const [TargetFont, setTargetFont] = useState('Fibel');
    const [TargetType, setTargetType] = useState('Text');
    const [inTutorium, setInTutorium] = useState(false);
    const [inDiagnose, setInDiagnose] = useState(false);
    const [inDiagnose2, setInDiagnose2] = useState(false);
    const [tutCounter, setTutCounter] = useState(0); 
    const [buttonAktiv, setButtonAktiv] = useState(false);
    const [RetestButtonJa, setRetestbuttonJa] = useState('LinkshanderButton aktiv');
    const [RetestButtonNein, setRetestbuttonNein] = useState('RechtshanderButton inaktiv');
    const [StimulusText, setStimulusText] = useState('');
    const [StimulusType, setStimulusType] = useState('Fibel');
    const [cycleCounter1, setCycleCounter1] = useState(0);
    const [cycleCounter2, setCycleCounter2] = useState(0);
    const [stimulusCounter1, setStimulusCounter1] = useState(0);
    const [stimulusCounter2, setStimulusCounter2] = useState(0);
    const [slsCounter, setSlsCounter] = useState(0);
    const [stimulusOnsetTime, setStimulusOnsetTime] = useState(0);
    const [items, setItems] = useState([]);
    const [targetUsed, setTargetUsed] = useState([]);
    const [itemsUsed, setItemsUsed] = useState([]);
    const [targetOnsetTime, setTargetOnsetTime] = useState(0);
    const [targetDelta, setTargetDelta] = useState([]);
    const [s1Used, setS1Used] = useState([]);
    const [s2Used, setS2Used] = useState([]);
    const [s3Used, setS3Used] = useState([]);
    const [s4Used, setS4Used] = useState([]);
    const [s1Delta, setS1Delta] = useState([]);
    const [s2Delta, setS2Delta] = useState([]);
    const [s3Delta, setS3Delta] = useState([]);
    const [s4Delta, setS4Delta] = useState([]);
    const [s1Antwort, setS1Antwort] = useState([]);
    const [s2Antwort, setS2Antwort] = useState([]);
    const [s3Antwort, setS3Antwort] = useState([]);
    const [s4Antwort, setS4Antwort] = useState([]);
    const [anzahlRichtige, setAnzahlRichtige] = useState(0);
    const [startzeitPhase2, setStartzeitPhase2] = useState(0);
    const [itemsPre, setItemsPre] = useState([]);
    const [hilfeWort, setHilfeWort] = useState(false);
    const [inHilfePhase, setInHilfePhase] = useState(false);
    const [e_oneshot, set_o_oneshot] = useState(false);
    {/*Variablen Testung*/ }

    
    {/*Variablen f�r Ablauf*/ }
    const sequenz_intervall = [18200, 29300, 29400,1000, 15600, 25200, 36500,38500,3200, 9300, 16100,18000,
        3600, 9100, 9200, 9200,2000, 6100, 10100, 10200,1000, 2300, 2500, 2500,1300, 1500, 1500,2300, 2500, 2500,
        11000,2000, 10000, 22000, 29200, 31000,3200, 7400, 12200, 2000, 5600, 5600,9500, 
        2000, 2000, 2000,2000,2000,2000,2000,2000,2000,2000,2000]

    const tutorial_Items = ["efte", "elte", "erfte","h\u00f6nt", "h\u00f6lt", "hond",
        "Tee kann man trinken.", "V\u00f6gel legen Eier.", "Erdbeeren sind ganz blau.", "img001", "Maus", "Maul", "bale", "bafe", "bole"]
    {/*Variablen f�r Ablauf*/ }


    const LogIn = () => {
        if(schulerCode && userCode !== "Keiner")
        {
            orderItems();                
        }
        else{
            setFastLoginError("Login-Error")
            if(schulerCode){setFastLoginError("Engine-Login-Error")}
            if(userCode !== "Keiner"){setFastLoginError("Schülerdaten fehlen")} 
        }
    }         
   
    
    {/*Kernmethoden*/ }
    const startePhase1 = () => {startSeiteAusblenden();setInDiagnose(true);setTicketMonitor("TicketMonitor gone");
        setProgressBarVisible("ProgressbarWrapper");
        cycle_Phase1();}
    
    const cycle_Phase1 = () => {var currentCycle = cycleCounter1;verbergeTargetKlein();
        setCycleCounter2(currentCycle);
        setCycleCounter1(cycleCounter1 + 1);
        setForceSteps(forceSteps+1);
        TargetPhase(items[currentCycle][2], items[currentCycle][0],items[currentCycle][1]);}
    
    const cycle_Phase2 = () => {var currentSLSstimulus = cycleCounter1;setStimulusCounter1(0);
        if(items[currentSLSstimulus][2] != undefined && currentSLSstimulus < 28) 
        {
            setTargetType("4");
            setCycleCounter2(currentSLSstimulus);setCycleCounter1(cycleCounter1 + 1);itemTafelEinblenden();buttonDeaktivieren();stimulusEinblenden("...");playTimeSound();
            setTimeout(() => { stimulusEinblenden("..", "1"); playTimeSound(); }, 1000)
            setTimeout(() => { stimulusEinblenden(".", "1"); playTimeSound(); }, 2000)
            setTimeout(() => {stimulusEinblenden(items[currentSLSstimulus][2], "4");zeitpunktTargetDarbietung(items[currentSLSstimulus][2], items[currentSLSstimulus][0]);
            if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}setButtonAktiv(true);playStim();}, 3000)
        }
        else
        {
            DiagnoseBeenden();
        }
        }

    const TargetPhase = (tar, id, typ) =>{buttonVerbergen();TargetVerbergen();itemTafelVerbergen();stimulusVerbergen();zeigeLupeGross();playTarget();
        setTutorText('24b');
        setInHilfePhase(true);
        setTimeout(() => { setTutorScreen('Talk'); }, 0)
        setTimeout(() => { setTutorText('0')}, 2500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0')}, 4000)
        setTimeout(() => { setTutorScreen('Android'); setTutorText('0')}, 5000)
        setTimeout(() => { zeigeTargetGroß(tar, typ); setHilfeWort(tar); zeitpunktTargetDarbietung(tar, id); }, 3500);
        setTimeout(() => { weiterButtonAktivieren(); setButtonAktiv(true); }, 3800);
      }
        

    const zeitpunktTargetDarbietung = (tar, id) => {var targetDarbietungszeitpunkt = Date.now();
        setTargetOnsetTime(targetDarbietungszeitpunkt);
        var gewahltesItem = id;var gewahlterTarget = tar;targetUsed.push(gewahlterTarget);itemsUsed.push(gewahltesItem);}
    
    const zeitpunktTargetBearbeitet = () => {var targetBearbeitetZeitpunkt = Date.now();var targetZeitDifferenz = targetBearbeitetZeitpunkt - targetOnsetTime;targetDelta.push(targetZeitDifferenz);}

    const stimulusCycle = () => {var currentStimulus = stimulusCounter1;setStimulusCounter2(currentStimulus);setStimulusCounter1(stimulusCounter1 + 1);
        setInHilfePhase(false);
        TargetVerbergen();zeigeTargetKlein();itemTafelEinblenden();buttonDeaktivieren();stimulusEinblenden("...", "1");playTimeSound();
        setTimeout(() => { stimulusEinblenden("..", "1"); playTimeSound();buttonDeaktivieren() }, 1000)
        setTimeout(() => { stimulusEinblenden(".", "1"); playTimeSound(); }, 2000)
        setTimeout(() => {stimulusEinblenden(items[cycleCounter2][3 + currentStimulus], items[cycleCounter2][1] );zeitpunktStimulusDarbietung();
            if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}
            setButtonAktiv(true);playStim();}, 3000)}

    const zeitpunktStimulusDarbietung = () => {var stimulusDarbietungszeitpunkt = Date.now();setStimulusOnsetTime(stimulusDarbietungszeitpunkt);}

    const zeitPunktStimulusBearbeitet = (welcher) => {
        var stimulusBearbeitetZeitpunkt = Date.now();
        var gewahlterStimulus = items[cycleCounter2][3 + stimulusCounter2];
        var stimulusDelta = stimulusBearbeitetZeitpunkt - stimulusOnsetTime;
        setInHilfePhase(false);

        if (welcher === 0) {s1Delta.push(stimulusDelta);s1Used.push(gewahlterStimulus);}
        if (welcher === 1) {s2Delta.push(stimulusDelta);s2Used.push(gewahlterStimulus);}
        if (welcher === 2) {s3Delta.push(stimulusDelta);s3Used.push(gewahlterStimulus);}
        if (welcher === 3) {s4Delta.push(stimulusDelta);s4Used.push(gewahlterStimulus);}}
    
    const antworte = (mit, welche) => {var antwort = mit;
        if (welche === 0) {s1Antwort.push(antwort);}
        if (welche === 1) {s2Antwort.push(antwort);}
        if (welche === 2) {s3Antwort.push(antwort);}
        if (welche === 3) {s4Antwort.push(antwort);}
        if (antwort=== true && items[cycleCounter2][3 + welche] === items[cycleCounter2][2])
        {
            doStepLightSide();
        }
        if (antwort=== false && items[cycleCounter2][3 + welche] != items[cycleCounter2][2])
        {
            doStepLightSide();
        }

        if (antwort=== false && items[cycleCounter2][3 + welche] === items[cycleCounter2][2])
        {
            doStepDarkSide();
        }
        if (antwort=== true && items[cycleCounter2][3 + welche] != items[cycleCounter2][2])
        {
            doStepDarkSide();
        }

    }
    
    const antworte2 = (mit, welche, wiegut) => {
        var antwort2 = mit;
        setSlsCounter(slsCounter+1);
        if (mit === true && wiegut === "1") {s1Delta.push(1);setAnzahlRichtige(anzahlRichtige + 1);}
        if (mit === true && wiegut === "0") {s1Delta.push(0);}
        if (mit === false && wiegut === "0") {s1Delta.push(1);setAnzahlRichtige(anzahlRichtige + 1);}
        if (mit === false && wiegut === "1") {s1Delta.push(0);}}
    
    const loben = () => {

        if(mood > 7)
        {
            var lobauswahl = Math.floor(Math.random() * 10);
            if (lobauswahl === 0){ cycle_Phase1();}
            if (lobauswahl === 1) {lob1();setTutorScreen('Loben');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 2) {lob2();setTutorScreen('Loben');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 3) {lob3();setTutorScreen('Talk');setTimeout(() => {  set_o_oneshot(false);cycle_Phase1(); }, 5000)}
            if (lobauswahl === 4) {lob4();setTutorScreen('Loben');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 5000)}
            if (lobauswahl === 5) {lob5();setTutorScreen('Loben');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 6) {lob6();setTutorScreen('Love');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 7) {lob7();setTutorScreen('Love');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 8) {lob8();setTutorScreen('Love');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 9) {cycle_Phase1();}
            if (lobauswahl === 10) {cycle_Phase1();}
        }
        if(mood <= 7 && mood >2)
        {
            var lobauswahl = Math.floor(Math.random() * 2);
            if (lobauswahl === 0) {lobM1();setTutorScreen('Doubt');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 1) {lobM1();setTutorScreen('Doubt');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}
            if (lobauswahl === 2) {lobM2();setTutorScreen('Doubt');setTimeout(() => { set_o_oneshot(false); cycle_Phase1(); }, 4000)}

        }

        if(mood <= 2)
        {
            var lobauswahl = Math.floor(Math.random() * 2);
            if (lobauswahl === 0) {lobS1();setTutorScreen('StopIt');setTimeout(() => {set_o_oneshot(false); cycle_Phase1(); }, 11000)}
            if (lobauswahl === 1) {lobS1();setTutorScreen('StopIt');setTimeout(() => {set_o_oneshot(false); cycle_Phase1(); }, 11000)}
            if (lobauswahl === 2) {lobS2();setTutorScreen('StopIt');setTimeout(() => {set_o_oneshot(false); cycle_Phase1(); }, 11000)}

        }
       
    }

    const helfen = () =>{
        if(inHilfePhase==true && e_oneshot == false)
        {
            set_o_oneshot(true);
            let bei = hilfeWort;               
                    if(bei=="Entenerpel"){e_Entenerpel();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="Feigenkerne"){e_Feigenkerne();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="verbogen"){e_verbogen();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="geliket"){e_geliket();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="Pudelbeine"){e_Pudelbeine();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="Notenhefte"){e_Notenhefte();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="gelogen"){e_gelogen();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
                    if(bei=="downloaden"){e_downloaden();setTutorScreen('Talk');setTimeout(() => { setTutorScreen('Neutral') }, 10000)}
        }
            
                
             
    }
    
    const DiagnoseBeenden = () => {
        
            stimulusVerbergen();
            buttonVerbergen();
            abschlussSound();
            ergebnisseSenden();
            setTutorText('38b')
            setTimeout(() => { setTutorScreen('Talk'); setTutorText('39')}, 10)
            setTimeout(() => { setTutorScreen('Loben'); setTutorText('40') }, 3200)
            setTimeout(() => { setTutorScreen('Talk'); setTutorText('41') }, 9000)
            setTimeout(() => { setTutorScreen('Neutral'); }, 13000)
            setTimeout(() => { setTutorScreen('Android'); setDiagnoseSeite("diagnoseseite gone"); setViewAbschlussSeite('AbschlussSeite')}, 15000)   
        
        
    }

    const doStepLightSide = () =>{
        if(theDarkSide >0)
        {
            setTheDarkSide(theDarkSide-20);
        }
        if(theLightSide < 255)
        {
            setTheLightSide(theLightSide+20);
        }
        if(mood < 10)
        {
            setMood(mood+2);
        }
                
    }

    const doStepDarkSide = () =>{
        if(theDarkSide < 255)
        {
            setTheDarkSide(theDarkSide+20);
        }
       
        if(theLightSide > 0)
        {
            setTheLightSide(theLightSide-20);
        }

        if(mood>0)
        {
            setMood(mood-1);
        }

    }
    
    {/*Kernmethoden*/ }

    {/*ButtonClicks*/ }
    const handleStart = () =>{
        
            if(userCode != null)
            {
               setSzene('diagnoseszene');starteTutorial_Phase1();
            } 
    }

    const handleWeiterClick = () =>{if (buttonAktiv){
        if(inDiagnose){setButtonAktiv(false)};
            if (inTutorium) {if (tutCounter === 1) { s_tut2(); }if (tutCounter === 6) { s_tut6(); } if (tutCounter === 11) { s_tut12(); } if (tutCounter === 80) { s_reTut2(); }}
            if (inDiagnose){weiterButtonDeaktivieren();buttonDeaktivieren();zeitpunktTargetBearbeitet();stimulusCycle(); 
             if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();} 
            }buttonDeaktivieren();}}

    
            const handleRechtsClick = () =>{if (buttonAktiv) {if(inDiagnose){setButtonAktiv(false)}; if (rechtsy) {handleJa();}if (rechtsy === false) {handleNein();}}}
            const handleLinksClick = () =>{if (buttonAktiv) {if(inDiagnose){setButtonAktiv(false)};if (rechtsy) {handleNein();}if (rechtsy === false) {handleJa();}}}

    const handleJa = () =>
    {
        if (inTutorium) {if (tutCounter === 2) { s_tut3();}if (tutCounter === 7) { s_tut7();}if (tutCounter === 9) { s_tut11(); }if (tutCounter === 21) { s_tut9();}if (tutCounter === 23) { s_tut_phase2_finish();} if (tutCounter === 12) { s_tut13();} if (tutCounter === 81) { s_reTut3();}}
        
        if (inDiagnose){playButtonSound();setButtonAktiv(false);zeitPunktStimulusBearbeitet(stimulusCounter2);antworte(true, stimulusCounter2);buttonDeaktivieren();
            if (cycleCounter2 < itemAnzahlPhase1-1) {
                if (stimulusCounter2 < 3){stimulusCycle();}else{setStimulusCounter1(0);loben();}}
            if (cycleCounter2 === itemAnzahlPhase1-1) {if (stimulusCounter2 < 3) {stimulusCycle();} if (stimulusCounter2 === 3) {setStimulusCounter1(0);s_tut_phase2_start();}if (stimulusCounter2 > 3) {setStimulusCounter1(0);s_tut_phase2_start();}}
            if (cycleCounter2 > itemAnzahlPhase1-1) {setStimulusCounter1(0);s_tut_phase2_start();}
            var newProgress = progress+1.25;
            setProgress(newProgress);}

        if (inDiagnose2) {playButtonSound();setButtonAktiv(false);zeitpunktTargetBearbeitet(stimulusCounter2);
            antworte2(true, cycleCounter2, items[cycleCounter2][8]);buttonDeaktivieren();var newSLSCounter = slsCounter+1;setSlsCounter(newSLSCounter);
            var zwischenZeit = Date.now();
            if (zwischenZeit - startzeitPhase2 < testDauerPhase2) {cycle_Phase2();}else {DiagnoseBeenden();}}
    }

    const handleNein = () =>
    {
        if (inTutorium) {if (tutCounter === 3) { s_tut4();}if (tutCounter === 8) { s_tut8();}if (tutCounter === 5) { s_tut5(); }if (tutCounter === 22){ s_tut10();} if (tutCounter === 13){ s_tut_phase1_finish();} if (tutCounter === 82){ s_tut_phase1_finish();}}

        if (inDiagnose) {playButtonSound();setButtonAktiv(false);zeitPunktStimulusBearbeitet(stimulusCounter2);antworte(false, stimulusCounter2);buttonDeaktivieren();
            console.log("Logging: CycleCounter="+cycleCounter2+"; StimulusCounter="+stimulusCounter2);
            if (cycleCounter2 < itemAnzahlPhase1-1) {if (stimulusCounter2 < 3) {stimulusCycle();} else {setStimulusCounter1(0);loben();}}
            if (cycleCounter2 === itemAnzahlPhase1-1) {
                if (stimulusCounter2 < 3) {stimulusCycle();}if (stimulusCounter2 === 3) {console.log("Logging: Gehe in Phase 2"); setStimulusCounter1(0);s_tut_phase2_start();} if (stimulusCounter2 > 3) {setStimulusCounter1(0);s_tut_phase2_start();}}
            if (cycleCounter2 > itemAnzahlPhase1-1) {console.log("Logging: Gehe in Phase 2"); setStimulusCounter1(0);s_tut_phase2_start();}
            var newProgress = progress+1.25;setProgress(newProgress);}

        if (inDiagnose2) {playButtonSound();setButtonAktiv(false);zeitpunktTargetBearbeitet(stimulusCounter2);antworte2(false, cycleCounter2, items[cycleCounter2][8]);buttonDeaktivieren();
            var newSLSCounter = slsCounter+1;setSlsCounter(newSLSCounter);var zwischenZeit = Date.now();
            if (zwischenZeit - startzeitPhase2 < testDauerPhase2) {cycle_Phase2();}else {DiagnoseBeenden();}}}

    {/*ButtonClicks*/ }

    {/*Steuerung der Componenten*/ }
    const startSeiteAusblenden = () => {setDatenSeite('datenseite gone');}
    const diagnoseSeiteEinblenden = () =>{setDiagnoseSeite('diagnoseseite');}
    const zeigeTargetGroß = (t, ty) => { setTargetVisible('TargetWrapperGroß'); setTargetText(t); setTargetType(ty)}
    const weiterButtonAktivieren = () => {if(Theme=="SecretDucks"){setWeiterButton('WeiterButtonSD');}if(Theme=="Default"){setWeiterButton('WeiterButtonDefault');}}
    const weiterButtonDeaktivieren = () => {setWeiterButton('WeiterButton gone');}
    const TargetVerbergen = () => {setTargetVisible('TargetWrapperGroß gone');}
    const zeigeLupeGross = () => {}
    const zeigeTargetKlein = (t3) => {setTargetKleinVisible('TargetKleinWrapper')}
    const verbergeTargetKlein = () => {setTargetKleinVisible('TargetKleinWrapper gone')}
    const itemTafelEinblenden = () => {setStimulusWrapper('StimulusWrapper');}
    const itemTafelVerbergen = () => {setStimulusWrapper('StimulusWrapper gone');}
    const stimulusEinblenden = (t2, ty) => {setStimulusText(t2); setStimulusType(ty);}
    const jaButtonEinblendenRechtsy = () => {setButtonRechts('ButtonRechts'); setButtonRechtsType('Same');}
    const neinButtonEinblendenRechtsy = () => {setButtonLinks('ButtonLinks'); setButtonLinksType('Different');}
    const jaButtonEinblendenLinksy = () => {setButtonLinks('ButtonLinks'); setButtonLinksType('Same');}
    const neinButtonEinblendenLinksy = () => {setButtonRechts('ButtonRechts'); setButtonRechtsType('Different');}
    const buttonDeaktivieren = () => {setButtonRechtsType('Inaktiv');setButtonLinksType('Inaktiv');}
    const stimulusVerbergen = () => {setStimulusText('')}
    const buttonVerbergen = () => {setButtonRechts('ButtonRechts gone'); setButtonLinks('ButtonLinks gone');}
    const buttonAktivierenRechtsy = () => {setButtonRechts('ButtonRechts'); setButtonRechtsType('Same');setButtonLinks('ButtonLinks'); setButtonLinksType('Different');}
    const buttonAktivierenLinksy = () => {setButtonLinks('ButtonLinks'); setButtonLinksType('Same');setButtonRechts('ButtonRechts'); setButtonRechtsType('Different');}
    {/*Steuerung der Componenten*/ }


    {/*Skripting*/ }
    const starteTutorial_Phase1 = () =>{startSeiteAusblenden();diagnoseSeiteEinblenden();setInTutorium(true);
        console.log("retest = "+reTest);
        if(reTest == "false"){s_tut1();} 
        else{s_reTut1();}}

    const s_tut1 = () => {setTutCounter(1);zeigeLupeGross();moderation1();
        setTimeout(() => { setTutorScreen('Talk') }, 500)
        setTimeout(() => { setTutorText('1') }, 600)
        setTimeout(() => { setTutorScreen('Think');setTutorText('2') }, 11900)
        setTimeout(() => { setTutorScreen('Talk');}, 15500)
        setTimeout(() => { setTutorText('3') }, 16000)
        setTimeout(() => { setTutorScreen('Point') }, 19000)
        setTimeout(() => { setTutorText('4') }, 19500)
        setTimeout(() => { setTutorScreen('Talk') }, 21000)
        setTimeout(() => { setTutorText('5') }, 25000)
        setTimeout(() => { setTutorScreen('Point') }, 29000)
        setTimeout(() => { zeigeTargetGroß(tutorial_Items[0], "1"); }, 19500)
        setTimeout(() => { weiterButtonAktivieren(); }, 30000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 31000)
        setTimeout(() => { setButtonAktiv(true); }, 33000)}
    
    const s_tut2 = () => {setTutCounter(2);TargetVerbergen(); weiterButtonDeaktivieren();setButtonAktiv(false);zeigeTargetKlein(tutorial_Items[0],"1");moderation2();setTutorText('5b'); 
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('6') }, 100)
        setTimeout(() => { setTutorScreen('Point') }, 8000)
        setTimeout(() => { itemTafelEinblenden();stimulusEinblenden(tutorial_Items[0], "1"); }, 8500)
        setTimeout(() => { setTutorScreen('Talk') }, 9000)
        setTimeout(() => { setTutorText('7') }, 9500)
        setTimeout(() => { setTutorText('8') }, 21000)
        setTimeout(() => { setTutorScreen('Point') }, 18500)
        setTimeout(() => { setTutorScreen('Talk') }, 20500)
        setTimeout(() => { setTutorScreen('Point') }, 29000)
        setTimeout(() => { setTutorScreen('Talk') }, 30500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 31000)
        setTimeout(() => { if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 21000)
        setTimeout(() => { if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 30000)
        setTimeout(() => { setButtonAktiv(true); }, 33000)}
    
    const s_tut3 = () => {setTutCounter(3);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation3();setTutorText('8b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('9') }, 100)
        setTimeout(() => { setTutorScreen('Point') }, 2500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[1], "1"); }, 3200)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('10') }, 4000)
        setTimeout(() => { if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 13800)
        setTimeout(() => {if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 13800)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 13000)
        setTimeout(() => { setButtonAktiv(true); }, 14000)} 
    
    const s_tut4 = () => {setTutCounter(5);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation4();setTutorText('10b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('11') }, 100)
        setTimeout(() => { setTutorScreen('Point') }, 2500)
        setTimeout(() => { setTutorScreen('Talk') }, 4000)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[2], "1"); }, 3500)
        setTimeout(() => {if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 8500)
        setTimeout(() => {if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 8500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 9000)
        setTimeout(() => { setButtonAktiv(true); }, 8500)}
    
    const s_tut5 = () => {setTutCounter(6);setButtonAktiv(false);stimulusVerbergen();itemTafelVerbergen();TargetVerbergen();buttonVerbergen();moderation6();verbergeTargetKlein();
        setTutorText('11b');
        setTimeout(() => { setTutorScreen('Think'); setTutorText('12') }, 100)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('13')}, 3000)
        setTimeout(() => { setTutorScreen('Oh') }, 7000)
        setTimeout(() => { setTutorScreen('Talk') }, 8500)
        setTimeout(() => { setTutorScreen('Point') }, 9000)
        setTimeout(() => { setTutorScreen('Talk') }, 10500)
        setTimeout(() => { zeigeTargetGroß(tutorial_Items[3], "1"); }, 10000)
        setTimeout(() => { setTutorText('14')}, 9000)
        setTimeout(() => { weiterButtonAktivieren(); }, 14500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 15000)
        setTimeout(() => { setButtonAktiv(true); }, 15000)}  
    
    const s_tut6 = () => {setTutCounter(7);weiterButtonDeaktivieren();setButtonAktiv(false);zeigeTargetKlein();TargetVerbergen();buttonDeaktivieren();moderation7();setTutorText('14b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('15')}, 0)
        setTimeout(() => { setTutorScreen('Point') }, 2000)
        setTimeout(() => { setTutorScreen('Talk') }, 3500)
        setTimeout(() => { itemTafelEinblenden(); }, 3000)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[3], "1"); }, 3500)
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 9000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 9200)
        setTimeout(() => { setButtonAktiv(true); }, 9500)}
    
    const s_tut7 = () => {setTutCounter(8);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation8(); setTutorText('15b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('16')}, 10)
        setTimeout(() => { setTutorScreen('Point') }, 1000)
        setTimeout(() => { setTutorScreen('Talk') }, 2000)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[4], "1"); }, 1500)
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 5500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 6000)
        setTimeout(() => { setButtonAktiv(true); }, 6500)}
    
    const s_tut8 = () => {setTutCounter(9);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation9();setTutorText('16b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('17')}, 10)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[3],"1"); }, 2000)
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 2800)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 4000)
        setTimeout(() => { setButtonAktiv(true); }, 4500)}
    
    const s_tut_phase1_finish = () => {setTutCounter(10);moderation13();stimulusVerbergen();itemTafelVerbergen();verbergeTargetKlein();buttonVerbergen();TargetVerbergen();setInTutorium(false);
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('23')}, 10)
        setTimeout(() => { setTutorScreen('Talk'); }, 2500)
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('24')}, 11000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 13000)
        setTimeout(() => { startePhase1(); }, 13000)}   
    
    const s_tut9 = () => {setButtonAktiv(false);setTutCounter(22);moderation22();stimulusVerbergen();buttonDeaktivieren();
        setTutorText('30b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('31')}, 10)
        setTimeout(() => { setTutorScreen('Point') }, 3000)
        setTimeout(() => { setTutorScreen('Talk') }, 4500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[8], "1"); }, 3000);
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('32')}, 4000)
        setTimeout(() => {if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 12000)
        setTimeout(() => {if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 12000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 12500)
        setTimeout(() => { setButtonAktiv(true); }, 13000)}
    
    const s_tut10 = () => {setButtonAktiv(false);setTutCounter(23);stimulusVerbergen();moderation23();buttonDeaktivieren();
        setTutorText('32b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('33')}, 10)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[7], "1"); }, 3000);
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 5000)
        setTimeout(() => { setButtonAktiv(true); }, sequenz_intervall[41])}
    
    const s_tut11 = () => {setTutCounter(11); stimulusVerbergen();buttonDeaktivieren();itemTafelVerbergen();TargetVerbergen();buttonVerbergen();verbergeTargetKlein();moderation10();
        setTutorText('17b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('18')}, 10)
        setTimeout(() => { setTutorScreen('Point') }, 1000)
        setTimeout(() => { setTutorScreen('Talk') }, 11500)
        setTimeout(() => { zeigeTargetGroß(tutorial_Items[9], "3"); }, 11000);
        setTimeout(() => {  setTutorText('19')}, 11500);
        setTimeout(() => { weiterButtonAktivieren(); }, 18500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 19500)
        setTimeout(() => { setButtonAktiv(true); }, 20500)}
    
    const s_tut12 = () =>{setTutCounter(12);weiterButtonDeaktivieren();setButtonAktiv(false);zeigeTargetKlein();TargetVerbergen();buttonDeaktivieren();moderation11();
        setTutorText('19b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('20')}, 10)
        setTimeout(() => { itemTafelEinblenden(); }, 6000)
        setTimeout(() => { setTutorScreen('Point') }, 5000)
        setTimeout(() => { setTutorScreen('Talk') }, 6500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[10], "3"); }, 6000)
        setTimeout(() => { setTutorText('21')}, 10000)
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 12000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 12000)
        setTimeout(() => { setButtonAktiv(true); }, 12500)}
    
     const s_tut13 = () => {setTutCounter(13);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation12();
        setTutorText('21b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('22')}, 10)
        setTimeout(() => { setTutorScreen('Point') }, 2000)
        setTimeout(() => { setTutorScreen('Talk') }, 3500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[11],"3"); }, 3000)
        setTimeout(() => {if (rechtsy === true) {buttonAktivierenRechtsy();}else {buttonAktivierenLinksy();}}, 6200)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 7000)
        setTimeout(() => { setButtonAktiv(true); }, 7500)}
    
    
    const s_tut_phase2_finish = () => {setButtonAktiv(false);setInTutorium(false);stimulusVerbergen();buttonDeaktivieren();setInDiagnose2(true);moderation24();
        setTutorText('33b')
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('34')}, 10)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('35')}, 2500)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('36')}, 6000)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('37')}, 9000)
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('38')}, 13000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 16000)
        setTimeout(() => { setTutorScreen('Android'); }, 17500)
        setTimeout(() => { cycle_Phase2(); setStartzeitPhase2(Date.now()) }, 18000)}
    
    const s_tut_phase2_start = () => {setProgressBarVisible("ProgressbarWrapper gone");verbergeTargetKlein();
        if (itemsDa === false) {orderItems();}

        if (kurzVersion) {
            for (let k = 0; k < 20; k++) {itemsUsed.push(k);targetUsed.push(k);targetDelta.push(k);s1Delta.push(k);}}
        if(reTest == "false")
        {
        moderation21();
        startSeiteAusblenden();setInTutorium(true);setInDiagnose(false);
        setTutorText('25b');
        setTimeout(() => { setTutorScreen('Love'); setTutorText('26')}, 10)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('27')}, 2500)
        setTutCounter(21);setCycleCounter1(20);setButtonAktiv(false);stimulusVerbergen();itemTafelVerbergen();TargetVerbergen();buttonVerbergen();
        setTimeout(() => { setTutorScreen('Point') }, 11000)
        setTimeout(() => { setTutorScreen('Talk') }, 12500)
        setTimeout(() => { itemTafelEinblenden(); }, 12000)
        setTimeout(() => {  setTutorText('28')}, 13000)
        setTimeout(() => {  setTutorText('29')}, 15000)
        setTimeout(() => { setTutorScreen('Loben') }, 18000)
        setTimeout(() => { setTutorScreen('Talk') }, 21500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[6], "1"); }, 12000)
        setTimeout(() => {if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 23000)
        setTimeout(() => { setTutorText('30')}, 24000)
        setTimeout(() => { setTutorScreen('Oh') }, 25000)
        setTimeout(() => { setTutorScreen('Talk') }, 28000)
        setTimeout(() => {if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 32500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 33000)
        setTimeout(() => { setButtonAktiv(true); }, 33500)
        }
        if(reTest=="true"){DiagnoseBeenden();}}        
    
    const s_reTut1 = () =>
    {
        moderationRe1();
        setTutCounter(80);zeigeLupeGross();
        setTimeout(() => { setTutorScreen('Talk') }, 500);
        setTimeout(() => { setTutorText('80') }, 600);
        setTimeout(() => { setTutorText('81') }, 4500);
        setTimeout(() => { setTutorText('82') }, 11000)
        setTimeout(() => { setTutorScreen('Point') }, 15800)
        setTimeout(() => { setTutorText('83') }, 16500)
        setTimeout(() => { setTutorScreen('Talk') }, 18000)
        setTimeout(() => { setTutorScreen('Point') }, 20000)
        setTimeout(() => { zeigeTargetGroß(tutorial_Items[12], "1"); }, 16000)
        setTimeout(() => { weiterButtonAktivieren(); }, 21500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 23000)
        setTimeout(() => { setButtonAktiv(true); }, 24000)
    }

    const s_reTut2 = () =>
    {
        setTutCounter(81);TargetVerbergen(); weiterButtonDeaktivieren();setButtonAktiv(false);zeigeTargetKlein(tutorial_Items[12],"1");moderation2();setTutorText('5b'); 
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('6') }, 100)
        setTimeout(() => { setTutorScreen('Point') }, 8000)
        setTimeout(() => { itemTafelEinblenden();stimulusEinblenden(tutorial_Items[12], "1"); }, 8500)
        setTimeout(() => { setTutorScreen('Talk') }, 9000)
        setTimeout(() => { setTutorText('7') }, 9500)
        setTimeout(() => { setTutorText('8') }, 21000)
        setTimeout(() => { setTutorScreen('Point') }, 18500)
        setTimeout(() => { setTutorScreen('Talk') }, 20500)
        setTimeout(() => { setTutorScreen('Point') }, 29000)
        setTimeout(() => { setTutorScreen('Talk') }, 30500)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 31000)
        setTimeout(() => { if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 21000)
        setTimeout(() => { if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 30000)
        setTimeout(() => { setButtonAktiv(true); }, 33000)
    }

    const s_reTut3 = () =>{
        setTutCounter(82);setButtonAktiv(false);buttonDeaktivieren();stimulusVerbergen();moderation3();setTutorText('8b');
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('9') }, 100)
        setTimeout(() => { setTutorScreen('Point') }, 2500)
        setTimeout(() => { stimulusEinblenden(tutorial_Items[13], "1"); }, 3200)
        setTimeout(() => { setTutorScreen('Talk'); setTutorText('10') }, 4000)
        setTimeout(() => { if (rechtsy === true) {jaButtonEinblendenRechtsy();}else {jaButtonEinblendenLinksy();}}, 13800)
        setTimeout(() => {if (rechtsy === true) {neinButtonEinblendenRechtsy();}else {neinButtonEinblendenLinksy();}}, 13800)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 13000)
        setTimeout(() => { setButtonAktiv(true); }, 14000)
    }

    const s_reTut_finish = () =>{
        setTutCounter(90);moderation13();stimulusVerbergen();itemTafelVerbergen();verbergeTargetKlein();buttonVerbergen();TargetVerbergen();setInTutorium(false);
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('23')}, 10)
        setTimeout(() => { setTutorScreen('Talk'); }, 2500)
        setTimeout(() => { setTutorScreen('Loben'); setTutorText('24')}, 11000)
        setTimeout(() => { setTutorScreen('Neutral'); setTutorText('0') }, 13000)
        setTimeout(() => { startePhase1(); }, 13000)
    }
    {/*Skripting*/ }

     {/*Skripting*/ }

    {/*Kommunikation mit dem Backend*/ }   
       
    const orderItems = () => {
        setFastLoginError("Lade");   
        setTimeout(() => {setFastLoginError("Lade."); ;},1000) 
        setTimeout(() => {setFastLoginError("Lade.."); ;},2000)
        setTimeout(() => {setFastLoginError("Lade..."); ;},3000)
        setTimeout(() => {setFastLoginError("Lade...."); ;},4000)
        setTimeout(() => {setFastLoginError("Server-Error!");},5000)            
        Axios.post(Api+'getaidelitems',{testbogen: testbogen}).then((response)=>{
            if(response.data.length==20)
            {
                for (let iread = 0; iread < response.data.length; iread++)
                {
                    var itemId = response.data[iread].itemId;
                    var itemTarget = response.data[iread].target;
                    var itemtyp = response.data[iread].itemtyp;
                    var randomStimulus = [response.data[iread].stimulus1, response.data[iread].stimulus2, response.data[iread].stimulus3, response.data[iread].stimulus4, response.data[iread].stimulus5];
                    var randomNummer = [Math.floor(Math.random() * 5), Math.floor(Math.random() * 5), Math.floor(Math.random() * 5), Math.floor(Math.random() * 5), Math.floor(Math.random() * 5)];
                    if (randomNummer[0] != 0 && randomNummer[1] != 0 && randomNummer[2] != 0 && randomNummer[3] != 0 && randomNummer[4] != 0) {
                        var zwang = Math.floor(Math.random() * 4);
                        randomNummer[zwang] = 0;}
                    var itemS1 = randomStimulus[randomNummer[0]];
                    var itemS2 = randomStimulus[randomNummer[1]];
                    var itemS3 = randomStimulus[randomNummer[2]];
                    var itemS4 = randomStimulus[randomNummer[3]];
                    var itemS5 = randomStimulus[randomNummer[4]];
                    var itemRichtigkeit = "5";
                    var item = [itemId, itemtyp, itemTarget, itemS1, itemS2, itemS3, itemS4, itemS5, itemRichtigkeit];
                    itemsPre.push(item);}
    
                {/*Reihenfolge der Items randomisieren*/ }
                var ran1 = [];
                for (let rn = 0; rn < 20; rn++){ran1.push(rn);}
    
                for (let rn2 = 0; rn2 < 40; rn2++)
                {
                    var randNummer = [Math.floor(Math.random()*20), Math.floor(Math.random()*20)];
                    var safe = ran1[randNummer[0]];
                    ran1[randNummer[0]] = ran1[randNummer[1]];
                    ran1[randNummer[1]] = safe;}
   
                for (let ipush = 0; ipush < 20; ipush++){items.push(itemsPre[ran1[ipush]]);}                
                {/*Reihenfolge der Items randomisieren*/ }

                if(testbogen != "null")
                {
                    setStartButton('StartButton');
                    setTicketMonitor("TicketMonitor"); 
                }

                orderItems2();
                setItemsDa(true);  
                setFastLoginError(""); 
                setTicketMonitor("TicketMonitor");         
            }})}
    
    const orderItems2 = () => {
        Axios.get(Api+'getaidesitem').then((response) =>{
            for (let slsread = 0 ; slsread < 28; slsread++)
            {
                var itemId = response.data[slsread].itemId;
                var itemText = response.data[slsread].itemText;
                var itemRichtigkeit = response.data[slsread].itemkorrekt;
                var filler = "fill";
                var itemtyp = "SLS";
                var item = [itemId, itemtyp, itemText, filler, filler, filler, filler, filler, itemRichtigkeit];
                items.push(item);   
            }
            
            setFastLoginPop("FastLoginPop gone");
            setLoginOfflinePop("FastLoginPop gone");
            setLE_StartBut("LE_StartBut");
            setFullScreen();
            console.log(items);
            if(response.data.length>25)
            {
                setItemsDa(true);
            }
            else
            {
                orderItems2();
            }
        }).catch()
    }

    const abkurzung = () => {
        handleStart()
    }

    const ergebnisseSenden = () => { 
        setTimeout(() => {
            Axios.post(Api+'aideergebnisse', {
                Modus: modus,
                Nutzercode: userCode,
                SchulerCode: schulerCode,
                SchulerKlasse: schulerKlasse,
                TestTicket: testTicket,
                BenutzteItems: itemsUsed,
                BenutzteTargets: targetUsed,
                S1benutzt: s1Used,
                S2benutzt: s2Used,
                S3benutzt: s3Used,
                S4benutzt: s4Used,
                TargetDelta: targetDelta,
                S1Delta: s1Delta,
                S2Delta: s2Delta,
                S3Delta: s3Delta,
                S4Delta: s4Delta,
                S1Antwort: s1Antwort,
                S2Antwort: s2Antwort,
                S3Antwort: s3Antwort,
                S4Antwort: s4Antwort,
                Umfang: slsCounter, 
                lead: lead,})},1000);
            } 
   
    
    {/*Kommunikation mit dem Backend*/ }

    const setFullScreen = () =>{
        var doc = window.document;
        var docEl = doc.documentElement;
        var requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
    
        if (
          !doc.fullscreenElement &&
          !doc.mozFullScreenElement &&
          !doc.webkitFullscreenElement &&
          !doc.msFullscreenElement
        ) {
          requestFullScreen.call(docEl);
        } else {
          
        }
      }

  return (
    <div className="AiDe">
        <div className="AideL_Wrapper">
        <div className="Design" ><World Theme={Theme} Szene={Szene}></World></div>
            

            {/*Seite zur Dateneingabe*/ }
            <div className={DatenSeite}>
                <div className="DatenFeld">
                    <div className="LehrerCodeFeld">{"Willkommen " +schulerVorname +"!"}</div>
                    <div className={SchulerCodeFeld}>{schulerCode}</div>
                    <div className='SchulerKlassenFeld'>Klassenstufe: {schulerKlasse}</div>
                    <div className='TestbogenFeld'>Bogen: {testbogen} </div>
                    <div className={LE_StartBut} onClick={handleStart}>LOS!</div>
                </div>
                
                
            </div>
            {/*Seite zur Dateneingabe*/ }

            {/*Diagnoseumgebung*/ }
            <div className={DiagnoseSeite}>
                 <div className={TargetVisible}><TargetGroß World Theme={Theme} TargetText = {TargetText} TargetFont = {TargetFont} TargetType={TargetType}> </TargetGroß></div>
                 <div className='TutorWrapperTop'><Tutor Theme={Theme} ScreenImg={TutorScreen} ShowText={TutorText}></Tutor></div> 
                 <div className={StimulusWrapper}><Stimulus Theme={Theme} StimulusText={StimulusText} StimulusType={TargetType}></Stimulus></div>
                 <div className={ButtonBereich}>
                     <div className={ButtonLinks} onClick={handleLinksClick}><Button Theme={Theme} Type={ButtonLinksType}></Button></div>
                     <div className={ButtonRechts} onClick={handleRechtsClick}><Button Theme={Theme} Type={ButtonRechtsType}></Button></div>
                 </div>
                 <div className={TargetKleinVisible}><TargetKlein Theme={Theme} TargetText={TargetText} TargetType={TargetType}></TargetKlein></div>
                 <div className={WeiterButton} onClick={handleWeiterClick}><div className='WeiterButtonIcon'></div></div>
                 
            </div>
            {/*Diagnoseumgebung*/ }
            <div className={progressBarVisible}>
            <div className="ProgressbarFill" style={{width:progress+"%", backgroundColor:"rgb("+theDarkSide+","+theLightSide+","+25+")"}}></div>
                </div>
            <div className={ticketMonitor}>{"User: "+schulerCode}</div>
            <div className={repeatButton}></div>  
            <div className='ToggleFullScreen' onClick={setFullScreen}></div>
            <div className={FastLoginPop}>
                <div className='FastLoginError'>{FastLoginError}</div>
                <div className='FastLoginStart' onClick={LogIn}>START</div>
            </div>

            <div className={viewAbschlussSeite}>
                <div className='AbschlussTitel1'>Super!</div>
                <div className='AbschlussTitel2'>Du hast es geschafft und bist fertig!</div>
        </div>
        </div>
    </div>
  )
}

export default AiDe_LE